import React from 'react'

const DescriptionSurface = React.memo(
  React.forwardRef<HTMLDivElement>((_, ref) => (
    <div
      ref={ref}
      contentEditable
      suppressContentEditableWarning
      role="textbox"
      aria-multiline="true"
      className="min-h-24 select-text px-4 py-2 text-sm font-medium font-Montserrat leading-5 text-foregrounds-fg-base outline-none"
    />
  ))
)

export default DescriptionSurface
